import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { message } from '@docon/docon-ui-library';
import { Status } from 'redux/reducer';
import { DownloadLink } from 'shared';

function DownloadContainer() {
  const {
    candidatesReportsDownloadLink,
    candidatesReportsDownloadStatus,
    downloadFilteredReportsLink,
    downloadFilteredReportsStatus,
  } = useSelector((state) => state.reports);
  const {
    checkupStatusExcelDownloadLink,
    checkupStatusExcelDownloadStatus,
  } = useSelector((state) => state.checkup);
  const {
    scheduleCheckupExcelDownloadLink,
    scheduleCheckupExcelDownloadStatus,
  } = useSelector((state) => state.scheduleCheckup);
  const {
    downloadCandidateExcelLink,
    downloadAllCandidatesStatus,
    downloadAllCandidatesLink,
  } = useSelector((state) => state.candidate);
  const [downloadState, setDownloadState] = useState({ href: '', download: '' });

  useEffect(() => {
    if (downloadCandidateExcelLink) {
      setDownloadState({
        href: downloadCandidateExcelLink,
        download: 'BulkCandidate.csv',
      });
    }
  }, [downloadCandidateExcelLink]);

  useEffect(() => {
    switch (candidatesReportsDownloadStatus) {
      case Status.fulfilled:
        if (candidatesReportsDownloadLink) {
          setDownloadState({
            href: candidatesReportsDownloadLink,
            download: 'BulkReports.zip',
          });
          message.success('Reports Download Successfully');
        }
        break;
      case Status.rejected:
        message.error('Reports Download Failed');
        break;
    }
  }, [candidatesReportsDownloadStatus]);

  useEffect(() => {
    switch (downloadFilteredReportsStatus) {
      case Status.fulfilled:
        if (downloadFilteredReportsLink) {
          setDownloadState({
            href: downloadFilteredReportsLink,
            download: 'FilteredReports.csv',
          });
          message.success('Download Successfully');
        }
        break;
      case Status.rejected:
        message.error('Download Failed');
        break;
    }
  }, [downloadFilteredReportsStatus]);

  useEffect(() => {
    switch (downloadAllCandidatesStatus) {
      case Status.fulfilled:
        if (downloadAllCandidatesLink) {
          setDownloadState({
            href: downloadAllCandidatesLink,
            download: 'DownloadCandidates.csv',
          });
          message.success('Candidates csv Download Successfully');
        }
        break;
      case Status.rejected:
        message.error('Candidates csv Download Failed');
        break;
    }
  }, [downloadAllCandidatesStatus]);

  useEffect(() => {
    switch (checkupStatusExcelDownloadStatus) {
      case Status.fulfilled:
        if (checkupStatusExcelDownloadLink) {
          setDownloadState({
            href: checkupStatusExcelDownloadLink,
            download: 'CheckupStatus.csv',
          });
          message.success('Checkup Status csv Download Successfully');
        }
        break;
      case Status.rejected:
        message.error('Checkup Status csv Download Failed');
        break;
    }
  }, [checkupStatusExcelDownloadStatus]);

  useEffect(() => {
    switch (scheduleCheckupExcelDownloadStatus) {
      case Status.fulfilled:
        if (scheduleCheckupExcelDownloadLink) {
          setDownloadState({
            href: scheduleCheckupExcelDownloadLink,
            download: 'ScheduleCheckupStatus.csv',
          });
          message.success('Schedule Checkup Status csv Download Successfully');
        }
        break;
      case Status.rejected:
        message.error('Schedule Checkup Status csv Download Failed');
        break;
    }
  }, [scheduleCheckupExcelDownloadStatus]);

  if (downloadState.href)
    return <DownloadLink {...downloadState} />;

  return null;
}

export default DownloadContainer;